// @core/api/endpoints/payment/authorize_payment.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AuthorizePaymentRequest,
  AuthorizePaymentResponse,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * Authorize payment
 * Authorizes a payment (holds funds without capturing). Must be captured or voided within the hold period.
 */
export async function AuthorizePayment(
  data: AuthorizePaymentRequest,
  options?: RequestOptions
): Promise<AuthorizePaymentResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/payments/authorize`;
  const requestOptions = options;
  return client.post<AuthorizePaymentResponse>(requestPath, data, requestOptions);
}
